import { useState } from "react"

export const AddTask = ({onAdd}) => {
  const [text , setText] = useState('')
  const [day , setDay] = useState('')
  const [Reminder , setReminder] = useState(false)
   
  const onSubmit = (e) => {
    e.preventDefault()
  
  if(!text) {
    alert('please add a task')
    return
   }

   onAdd({ text , day ,Reminder})

   setText('')
   setDay('')
   setReminder(false)

}
    return (
    <form className='add-form' onSubmit={onSubmit}>
        <div className='form-control'>
            <label>Task</label>
            <input type='text' placeholder='Add Task'
            value={text} onChange={(e) => setText(e.target.value)}/>
        </div>
        <div className='form-control'>
            <label>day & Time</label>
            <input type='time' placeholder='Add Day & Time'
            value={day} onChange={(e) => setDay(e.target.value)}/>
        </div>
        <div className='form-control form-control-check'>
            <label> Set Reminder</label>
            <input 
            type='checkbox'
            checked={Reminder}
            value={Reminder} 
            onChange={(e) => setReminder(e.currentTarget.checked)}/>
        </div>

        <input type='submit' value='save Task' className="btn btn-block"/>
    </form>
  )
}

export default AddTask